import { connect, Component, Rendering } from 'macguffin'
import BackgroundImage from "utils/BackgroundImage"

import { Tween } from "@tweenjs/tween.js"

const messageBoxStyle = {
    backgroundPosition: "center",
    backgroundSize: "100% 100%"
}

const FONT_SCALE = 0.04

@connect(state => ({
    currentGameMode: state.game.currentGameMode,
    currentPickStageIndex: state.game.currentPickStageIndex,
    globalPaused: state.base.paused
}), {})
export default class MessageBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMessage: this.t('messagebox.main.message1'),
            animationName: 'scrollMessage1'
        }
    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidMount() {
        this.changeMessage()
    }

    changeMessage() {
        const { currentMessage, animationName } = this.state
        const { currentGameMode, currentPickStageIndex } = this.props
        let animationNameTemp;
        let currentMessageTemp;
        switch (animationName) {
            case 'scrollMessage1':
                animationNameTemp = 'scrollMessage2'
                break;

            case 'scrollMessage2':
                animationNameTemp = 'scrollMessage1'
                break;

            default:
                animationNameTemp = 'scrollMessage1'
                break;
        }

        if (currentGameMode === 'MAIN') {
            if (currentMessage === this.t('messagebox.main.message1')) {
                currentMessageTemp = this.t('messagebox.main.message2')
            }

            else {
                currentMessageTemp = this.t('messagebox.main.message1')
            }
        }

        if (currentGameMode === 'FREESPIN') {
            if (currentMessage === this.t('messagebox.freespin.message1')) {
                currentMessageTemp = this.t('messagebox.freespin.message2')
            }

            else {
                currentMessageTemp = this.t('messagebox.freespin.message1')
            }
        }

        if (currentGameMode === 'MARS_INTRO') {
            currentMessageTemp = this.t('messagebox.jackpot')
        }

        if (currentGameMode === 'JACKPOT_DRAW') {
            currentMessageTemp = this.t('messagebox.jackpotSummary')
        }

        if (currentGameMode === 'PICK') {
            if (currentMessage === this.t('messagebox.pick.pick1') ||
            currentMessage === this.t('messagebox.pick.pick2') ||
            currentMessage === this.t('messagebox.pick.pick3')) {
                currentMessageTemp = this.t('messagebox.pick.message')
            }
            else {
                switch (currentPickStageIndex) {
                    case 0:
                        currentMessageTemp = this.t('messagebox.pick.pick1')
                        break;

                    case 1:
                        currentMessageTemp = this.t('messagebox.pick.pick2')
                        break;

                    case 2:
                        currentMessageTemp = this.t('messagebox.pick.pick3')
                        break;
                }
            }
        }

        if (currentGameMode === 'COMET_WILDS' || currentGameMode === 'RESPIN') {
            currentMessageTemp = this.t('messagebox.comet.message')
        }

        this.setState({ animationName: animationNameTemp, currentMessage: currentMessageTemp })
        new Tween()
        .to({ }, 18000)
        .onComplete(() => {
            this.changeMessage()
        })
        .start()

    }

    render() {
        const { props, state } = this
        const { globalPaused, width, height } = props
        const { currentMessage, animationName } = state

        if (this.props.currentGameMode === 'BONUS_INTRO' || this.props.currentGameMode === 'BONUS_COUNTDOWN') {
            return (<div />)
        }

        const animationPlayState = globalPaused ? "paused" : "running"

        const fontSize = `${height * FONT_SCALE}px`

        return <BackgroundImage className="messageBoxContainer" assetName="messageBoxBackground" style={messageBoxStyle}>
            <div className="messageBox">
                <h1 style={{fontSize, animationName, animationPlayState }}>{currentMessage}</h1>
            </div>
        </BackgroundImage>
    }
}
